import { Footer } from '@/components/shared/Footer'
import React, { FC, ReactNode } from 'react'
import { Header } from './shared/Header'

type Props = Readonly<{
  children: ReactNode
}>

const Layout: FC<Props> = (props: Props) => {
  return (
      <div className="lg:relative">
        <Header/>

        <main>
          { props.children }
        </main>

        <Footer/>
      </div>
  )
}

export default Layout
